module.exports = __webpack_public_path__ + "img/header-diamondJewelryRosegold@2x.4ea6d19.jpg";